import * as crypto from 'node:crypto';

/** Excludes visually-ambiguous characters (0/O, 1/I) so codes are easy to read and type back in. */
const JOIN_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

const MONGO_DUPLICATE_KEY_ERROR_CODE = 11000;

/** True for the error Mongo throws when an insert/update violates the `classroom_code_unique` index. */
export function isDuplicateKeyError(err: unknown): boolean {
  return !!err && typeof err === 'object' && (err as { code?: number }).code === MONGO_DUPLICATE_KEY_ERROR_CODE;
}

export function generateJoinCode(length = 6): string {
  let code = '';
  for (let i = 0; i < length; i++) {
    code += JOIN_CODE_ALPHABET[crypto.randomInt(JOIN_CODE_ALPHABET.length)];
  }
  return code;
}

export function normalizeJoinCode(code: string): string {
  return typeof code === 'string' ? code.trim().toUpperCase() : '';
}
